import { readonly, ref, type DeepReadonly, type Ref } from 'vue';

export type ConfirmTone = 'default' | 'danger';

export interface ConfirmOptions {
  readonly title?: string;
  readonly message: string;
  readonly confirmLabel?: string;
  readonly cancelLabel?: string;
  readonly tone?: ConfirmTone;
}

export interface ConfirmRequest extends ConfirmOptions {
  readonly id: number;
}

const current = ref<ConfirmRequest | null>(null);
let resolver: ((accepted: boolean) => void) | null = null;
let nextId = 0;

function settle(accepted: boolean): void {
  const resolve = resolver;
  resolver = null;
  current.value = null;
  if (resolve !== null) {
    resolve(accepted);
  }
}

function ask(options: ConfirmOptions): Promise<boolean> {

  settle(false);
  nextId += 1;
  current.value = { id: nextId, ...options };
  return new Promise<boolean>((resolve) => {
    resolver = resolve;
  });
}

export interface ConfirmApi {
  readonly request: DeepReadonly<Ref<ConfirmRequest | null>>;
  ask(options: ConfirmOptions): Promise<boolean>;
  accept(): void;
  cancel(): void;
}

export function useConfirm(): ConfirmApi {
  return {
    request: readonly(current),
    ask,
    accept: () => settle(true),
    cancel: () => settle(false),
  };
}
